import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as S from '../Forms.styled';

import { RootState } from 'redux/store';
import { ProfileEditContext } from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/ProfileEditContext';

interface PartnerInfoSwitchProps {
    partnerActive: boolean;
    onSwitch: () => void;
}

const PartnerInfoSwitch = ({ partnerActive, onSwitch }: PartnerInfoSwitchProps) => {
    const profileEdit = useContext(ProfileEditContext);
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();

    if (profileEdit?.active) {
        return null;
    }

    return (
        <S.ButtonContainer>
            <S.partnerSwitchButton
                type="button"
                active={!partnerActive}
                onClick={partnerActive ? onSwitch : undefined}
            >
                {t('myInfo', { lng: language })}
            </S.partnerSwitchButton>
            <S.partnerSwitchButton
                type="button"
                active={partnerActive}
                onClick={!partnerActive ? onSwitch : undefined}
            >
                {t('partnerInfo', { lng: language })}
            </S.partnerSwitchButton>
        </S.ButtonContainer>
    );
};

export default PartnerInfoSwitch;
